import { Form, Formik } from "formik";
import React, { Fragment } from "react";

import { FormInfoProvider } from "@utils/forms/formInfo.provider";
import * as ValidationRules from "@utils/validations";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { TextField } from "@components/Form/FormFields/TextField/textField.component";
import { Button } from "@components/General/Button/button.component";

type Props = {
    buttonText: string;
    helperText: string;
    isBold: boolean;
    alignment: string;
    link: string;
};

const FORM_ID = "newsLetter";

const Newsletter = ({
    buttonText,
    link,
    helperText,
    isBold,
    alignment,
}: Props) => {
    const { t } = useGranite();
    // @ts-ignore
    const formElement = React.createRef<Formik>();
    const onFormSubmit = (form: any) => {
        location.assign(`${link}?email=${form.email}`);
    };

    return (
        <div>
            <div
                className={`h5 ${
                    isBold ? "font-weight-bold" : ""
                } ${alignment} mt-0`}
            >
                {helperText}
            </div>
            <FormInfoProvider formId={FORM_ID} withNeverbounce={true}>
                {({ initialized }) => (
                    <Formik
                        initialValues={{
                            email: "",
                        }}
                        onSubmit={onFormSubmit}
                        innerRef={formElement}
                    >
                        {() => (
                            <Fragment>
                                <Form id={FORM_ID}>
                                    <div className={"d-sm-flex"}>
                                        <div className={"flex-grow-1 mw-100"}>
                                            <TextField
                                                name="email"
                                                label={t(
                                                    "general.form.email.label",
                                                )}
                                                required
                                                hideLabel={true}
                                                hideMicroCopy={true}
                                                // @ts-ignore
                                                autocomplete={"email"}
                                                placeholder={t(
                                                    "general.form.email.placeholder",
                                                )}
                                                autoComplete={"email"}
                                                validationRule={
                                                    ValidationRules.emailWithNB
                                                }
                                                debounce={true}
                                                parseToString={true}
                                                disabled={!initialized}
                                            />
                                        </div>
                                        <div className={"px-sm-3"}>
                                            <Button
                                                data-test="newsletter-button-submit"
                                                className="text-center"
                                                color="primary"
                                                type={"submit"}
                                                block
                                                disabled={!initialized}
                                            >
                                                <strong>{buttonText}</strong>
                                            </Button>
                                        </div>
                                    </div>
                                </Form>
                            </Fragment>
                        )}
                    </Formik>
                )}
            </FormInfoProvider>
        </div>
    );
};

export default Newsletter;
